import { regenerateTokenServiceInterceptor } from "@/services/apis/auth.service";
import axios, { AxiosInstance } from "axios";

const instance: AxiosInstance = axios.create();

instance.interceptors.request.use(
  async (config) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(config);
      }, 0);
    });
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  async (response) => response,
  async (error) => {
    if (error?.response?.data?.statusCode === 4410) {
      try {
        await regenerateTokenServiceInterceptor();
        return axios(error.config);
      } catch (tokenError) {
        return Promise.reject(tokenError);
      }
    }

    return Promise.reject(error);
  }
);

export default instance;
